"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _TagManager = _interopRequireDefault(require("../TagManager"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var transaction = function transaction(order) {
  var products = (0, _map2["default"])(order.cart, function (item) {
    return {
      name: item.itemName,
      id: item.menuItemCode,
      price: item.price,
      quantity: item.quantity
    };
  });

  _TagManager["default"].pushToDataLayer({
    event: 'transaction',
    ecommerce: {
      purchase: {
        actionField: {
          id: order.storeId + "-" + order.id + "-" + order.pickupTime,
          revenue: order.cartTotal.toString(),
          tax: order.cartTaxes.toString(),
          coupon: order.promoCodeValue.toUpperCase(),
          type: order.serviceMethod.toString()
        },
        products: products
      }
    }
  });
};

var _default = transaction;
exports["default"] = _default;